module.exports = __webpack_public_path__ + "img/video_editor_empty.96014f6a.svg";